module.exports = __webpack_public_path__ + "img/thumb_19.3f761c03.jpg";